import { FC, ReactNode } from 'react';
import { Flex, Text } from '@servicetitan/anvil2';

export const TitleValue: FC<{ title: string; value: string | number }> = ({ title, value }) => {
    return (
        <Flex direction="column">
            <Text size="small" variant="eyebrow">
                {title}
            </Text>
            <Text size="small">{value}</Text>
        </Flex>
    );
};

export const TitleWithValueComponent: FC<{ title: string; value: ReactNode }> = ({
    title,
    value,
}) => {
    return (
        <Flex direction="column">
            <Text size="small" variant="eyebrow">
                {title}
            </Text>
            {value}
        </Flex>
    );
};
